// eslint-disable-next-line zillow/import/no-unresolved
var shouldShowContactAgentForm = function shouldShowContactAgentForm(property, abTests) {
  var homeStatus = property.homeStatus,
      homeType = property.homeType,
      isInstantOfferEnabled = property.isInstantOfferEnabled,
      zillowOfferMarket = property.zillowOfferMarket;
  var SHOW_PL_LEAD_FORM = abTests.SHOW_PL_LEAD_FORM;
  var selectedHomeType = ['APARTMENT', 'MULTI_FAMILY', 'CONDO', 'TOWNHOUSE', 'SINGLE_FAMILY'];
  var selectedMarket = ['CLT', 'RDU', 'ATL', 'PHX', 'TUS', 'RIV', 'ORL', 'SAN', 'SMF', 'LAO', 'PDX', 'AUS', 'SAT'];
  return homeStatus === 'OTHER' && selectedHomeType.includes(homeType) && selectedMarket.includes(zillowOfferMarket === null || zillowOfferMarket === void 0 ? void 0 : zillowOfferMarket.code) && !isInstantOfferEnabled && SHOW_PL_LEAD_FORM === 'ON';
};

export default shouldShowContactAgentForm;
//# sourceMappingURL=shouldShowContactAgentForm.js.map